import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const ArrowFirstIcon = createIcon(
  'ArrowFirst',
  <path
    id="a"
    d="M17.2925,6.2925 C16.9025,5.9025 16.2725,5.9025 15.8825,6.2925 L11.2925,10.8825 C10.9025,11.2725 10.9025,11.9025 11.2925,12.2925 L15.8825,16.8825 C16.2725,17.2725 16.9025,17.2725 17.2925,16.8825 C17.6825,16.4925 17.6825,15.8625 17.2925,15.4725 L13.4125,11.5825 L17.2925,7.7025 C17.6725,7.3125 17.6725,6.6725 17.2925,6.2925 Z M8,6 C8.55,6 9,6.41925 9,6.93166667 L9,16.2483333 C9,16.76075 8.55,17.18 8,17.18 C7.45,17.18 7,16.76075 7,16.2483333 L7,6.93166667 C7,6.41925 7.45,6 8,6 Z"
  />
);

export default ArrowFirstIcon;
